export class Sticky{
	init() {
		$(document).ready(function() {
			$(".reservation-box").first().stick_in_parent()
		});
	}
}